import { COLORS, fontSizes } from '../../../../constants/constants';
import { cn } from '../../../../utils/utils';
import { ViewItems, ErrorText } from '../index';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useEffect, useState } from 'react';
import Text from '../../../../components/Text';
const CustomDatePicker = ({
  label,
  errorMessage,
  isRequired = false,
  labelColor,
  placeholder = 'dd/mm/yyyy (Hijri)',
  width = 'w-full',
  onChange,
  selectedDate,
  minDate,
  maxDate,
  className,
  labelDivClass,
  isLabelHeight= false,
}) => {
  const [value, setValue] = useState(
    selectedDate ? new DateObject({ date: selectedDate }) : null
  );

  useEffect(() => {
    selectedDate && setValue(new DateObject({ date: selectedDate }));
  }, [selectedDate]);

  const handleChange = (val) => {
    setValue(val);
    if (onChange) {
      onChange(val ? val.toDate() : null);
    }
  };

  return (
    <ViewItems className={cn(width, className)}>
    {label && (
      <div className={cn(labelDivClass ? labelDivClass : isLabelHeight ? 'md:h-9' : "h-6")} >
        <Text
          text={label}
          size={fontSizes.h14}
          color={errorMessage ? "text-red-500" : labelColor}
          className={cn('leading-4', isLabelHeight && 'mb-1')}
          isRequired={isRequired}
          isTruncate={false}
        />
      </div>
    )}
      <div
        className={cn(
          'border w-full rounded-md py-1 px-2',
          errorMessage ? 'border-red-600' : 'border-border'
        )}
      >
        <DatePicker
          value={value}
          onChange={handleChange}
          minDate={minDate ? new DateObject({ date: minDate }) : undefined}
          maxDate={maxDate ? new DateObject({ date: maxDate }) : undefined}
          placeholder={placeholder}
          inputClass='w-full py-2 px-3 border rounded-md outline-none text-sm'
          containerClassName='custom-hijri-calendar w-full'
          className='w-full'
          style={{
            height: '30px',
            border: 'none',
            outline: 'none',
            fontSize: '14px',
            padding: '5px',
            color: COLORS ? COLORS?.neutral_grey : ''
          }}
          mapDays={({ date, today }) => {
            let props = {};
            if (today.day === date.day) {
              props.className = 'today-highlight';
            }
            return props;
          }}
        />
      </div>

      <ErrorText text={errorMessage} />
    </ViewItems>
  );
};

export default CustomDatePicker;
